import type { CartLineItem } from '@/modules/cart/domain/CartLineItem';

export const getProductAttribute = (
  product: CartLineItem,
  attributeName: string
): string => {
  const attributes = product?.variant?.attributes;
  const attributesKeyValue = Object.fromEntries(
    attributes?.map((attr) => [attr.name, attr.value]) ?? []
  );
  const value = attributesKeyValue[attributeName];

  if (typeof value === 'string') return value;

  if (typeof value === 'boolean') return value.toString();

  if (Array.isArray(value) && value.length > 0) return String(value[0]);

  if (
    typeof value === 'object' &&
    !Array.isArray(value) &&
    'key' in value &&
    'label' in value
  ) {
    return value?.label;
  }
  return '';
};
